import { component } from 'picoapp'
import Slider from '~/lib/slider'
import $ from 'quantdom'

export default component((node) => {
  const scrollTrack = $(node).find('[data-scroll-track]').el()
  const leftArrow = $(node).find('[data-arrow-left]').el()
  const rightArrow = $(node).find('[data-arrow-right]').el()
  let loaded = false
  let currentSlide = 0

  const slider = new Slider({ el: scrollTrack }, ({ isMin, isMax, index, filtering, slides, el }) => {
    if (loaded && currentSlide !== index) {
      currentSlide = index
      if (window?.gtag) {
        gtag('event', `Side Menu Slider Scrolled`, {
          event_detail: `${index + 1}`,
        })
      }
    }

    if (isMin) {
      leftArrow.setAttribute('disabled', true)
    } else {
      leftArrow.removeAttribute('disabled')
    }

    if (isMax) {
      rightArrow.setAttribute('disabled', true)
    } else {
      rightArrow.removeAttribute('disabled')
    }
  })

  $(leftArrow).on('click', (e) => {
    slider.slideLeft()
  })

  $(rightArrow).on('click', (e) => {
    slider.slideRight()
  })

  $(window).on('load', (e) => {
    slider.slideTo(0, 'instant')
    loaded = true
  })
})
